import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { areArraysEqual } from '@app/utils/utils';

import IndicationOrbs from '@components/indication-orbs/IndicationOrbs';
import NavTabElement from '@components/header/nav-tab-element/NavTabElement';
import './NavTabIndicator.scss';

export const shouldComponentUpdate = (prevProps, nextProps) =>
  // exists to prevent rerender if the array of tab elements hasn't changed
  areArraysEqual(prevProps.navTabsList, nextProps.navTabsList) &&
  prevProps.currentTabLocKey === nextProps.currentTabLocKey &&
  prevProps.currentTabId === nextProps.currentTabId;

const NavTabIndicator = React.memo(({ currentTabId, currentTabLocKey, navTabsList }) => {
  return (
    <div id="qau-header-nav-tab-indicator" data-testid="qau-header-nav-tab-indicator">
      <IndicationOrbs list={navTabsList} current={currentTabId} />
      <NavTabElement id={currentTabId} locKey={currentTabLocKey} active={true} />
    </div>
  );
}, shouldComponentUpdate);

const mapStateToProps = ({ header }) => {
  const { tabs: headerTabs } = header;
  const { id: currentTabId = '', locKey: currentTabLocKey = 'qau-empty-text' } = headerTabs.find(({ active }) => !!active) || {};
  const navTabsList = headerTabs.filter(({ hidden }) => !hidden).map(({ id }) => id); // only list of visible tabs must be presented for orbs count

  return {
    currentTabId,
    currentTabLocKey,
    navTabsList,
  };
};

NavTabIndicator.propTypes = {
  currentTabId: PropTypes.string.isRequired,
  currentTabLocKey: PropTypes.string.isRequired,
  navTabsList: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default connect(mapStateToProps)(NavTabIndicator);
